import $ from 'jquery';
class Pricelist {
    constructor(element) {
        document.addEventListener('DOMContentLoaded', () => this.load());
    }

    load() {

        const pricelists = document.querySelectorAll('.twz-element-pricelist__wrapper__items');

        if( pricelists.length ) {
            this.columns();
            this.slider(pricelists);
            this.popup();

            window.addEventListener('resize', () => {
                this.slider(pricelists);
            });
        }

    }

    slider(pricelists) {
        const Flickity = require('flickity');

        const noOfColumns = document.querySelector('.twz-element-pricelist__wrapper__items').children.length;

        if(pricelists.length && window.matchMedia("(max-width: 1366px)").matches && noOfColumns === 5) {
            document.querySelector('.twz-element-pricelist__wrapper__items').dataset.numbercolumns = 5;
            pricelists.forEach(pricelist => {
                pricelist.classList.add('grid--slide_on_mobile');

                const flkty = new Flickity(pricelist, {
                    cellAlign: 'center',
                    prevNextButtons: true,
                    pageDots: true,
                    selectedAttraction: 0.1,
                    friction: 0.65,
                    draggable: true,
                    watchCSS: true,
                    contain: true
                })
            })
            setTimeout(() => {
                document.querySelector('.twz-element-pricelist').classList.add('five--columns');
                document.querySelector('.twz-element-pricelist__wrapper__items').dataset.numbercolumns = 5;
            },500);

        } else if ( pricelists.length && window.matchMedia("(max-width: 1024px)").matches ) {
            pricelists.forEach(pricelist => {
                pricelist.classList.add('grid--slide_on_mobile');

                const flkty = new Flickity(pricelist, {
                    cellAlign: 'center',
                    prevNextButtons: true,
                    pageDots: true,
                    selectedAttraction: 0.1,
                    friction: 0.65,
                    draggable: true,
                    watchCSS: true,
                    contain: true
                })
            })
        } else {
            this.alignment();
            if (document.querySelector('.twz-element-pricelist').classList.contains('five--columns')) {
                document.querySelector('.twz-element-pricelist').classList.remove('five--columns')
            }
        }
    }

    popup() {
        const labels = document.querySelectorAll('.twz-element-pricelist__column_item .label');
        labels.forEach(label => {
            label.addEventListener('click', () => this.labelClick(label));
        })
    }

    labelClick(label) {
        this.removePopups(label);

        if (label.closest('.twz-element-pricelist__column_item').classList.contains('show_info')) {
            const labelName = label.dataset.label;
            const popup = label.parentElement.querySelector(`[data-popup="${labelName}"]`);
            popup.classList.add('show');

            popup.addEventListener('click', () => {
                popup.classList.remove('show');
                document.querySelector('html').classList.remove('no-scroll');
            });
            document.querySelector('html').classList.add('no-scroll');
        }
    }

    removePopups(label) {
        document.querySelectorAll('[data-popup]').forEach( popup => {
            if (popup.classList.contains('show')) {
                popup.classList.remove('show');
            }
        })
    }

    alignment() {
        const labels = document.querySelectorAll('.twz-element-pricelist__label');
        const heights = [];

        labels.forEach((label, i) => {
            heights[i] = label.clientHeight;
        })

        const columns = document.querySelectorAll('.twz-element-pricingcolumn');
        columns.forEach (column => {
            column.querySelectorAll('.twz-element-pricelist__column_option').forEach((item, index) => {
                item.style.height = heights[index] + "px";
            })
        })

        const topHeight = document.querySelectorAll('.twz-element-pricelist__column_head')[1].clientHeight;
        document.querySelector('.twz-element-pricelist__column_head').style.flexBasis = topHeight + "px";
    }

    columns() {
        const noOfColumns = document.querySelector('.twz-element-pricelist__wrapper__items').children.length;
        document.querySelector('.twz-element-pricelist__wrapper__items').dataset.numbercolumns = noOfColumns;
    }
}

new Pricelist;